import { render, staticRenderFns } from "./ProfileRecommendations.vue?vue&type=template&id=597cfa49&"
import script from "./ProfileRecommendations.vue?vue&type=script&lang=js&"
export * from "./ProfileRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports